import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const Create = lazy(() => import('./components/Create'))
const Detail = lazy(() => import('./components/Detail'))
const Edit = lazy(() => import('./components/Edit'))
const Home = lazy(() => import('./components/Home'))
const PublicFeedback = lazy(() => import('./components/PublicFeedback'))
const PublicTicketRating = lazy(() => import('./components/PublicTicketRating'))
const Templates = lazy(() => import('./components/Templates'))

const TicketModule: RouteObject = {
    path: 'tickets',
    children: [
        {
            path: '',
            element: <Home />,
        },
        {
            path: 'templates',
            element: <Templates />,
        },
        {
            path: ':ticketID',
            element: <Detail />,
        },
        {
            path: ':ticketID/edit',
            element: <Edit />,
        },
        {
            path: 'new',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

// Public feedback page (no auth required)
const TicketFeedbackPublic: RouteObject = {
    path: 'feedback',
    children: [
        {
            path: ':token',
            element: <PublicFeedback />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

// Public rating page, mounted by App.tsx under /util (no auth required):
// /util/feedback
const TicketPublicModule: RouteObject = {
    path: 'feedback',
    element: <PublicTicketRating />,
    errorElement: <ErrorPage status={500} />,
}

export default TicketModule
export { TicketFeedbackPublic, TicketPublicModule }
